import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger'
import { MessageResponse } from '../../message'

export class DashboardMessageView extends MessageResponse {
	@ApiProperty({ type: String })
	tableName: string

	@ApiPropertyOptional({ type: String })
	customerName?: string

	@ApiProperty({ type: Date })
	timestamp: Date
}
